import { ref, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6969118c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "card"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}, null, -1));
const _hoisted_5 = {
  class: "optionLabel"
};
const _hoisted_6 = {
  class: "optionDescribtion"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "内购ID自动生成规则：包名+内购名称，全小写，不超过140字符", -1));
const _hoisted_8 = {
  class: "card payCard"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 虚拟支付设置 ")], -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, "游戏币兑换比例，请与抖音后台配置保持一致", -1));
const _hoisted_11 = {
  class: "card priceCard"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 价格设置 ")], -1));
const _hoisted_13 = {
  class: "flex-list"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "price-box"
}, "CNY", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, "*仅支持抖音价格等级", -1));
const _hoisted_16 = {
  class: "flex-list"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, "*开启后该商品自动调整为测试价格", -1));
const _hoisted_18 = {
  class: "flex-list"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "price-box"
}, "CNY", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, "*最低测试价格为1元", -1));
const _hoisted_21 = {
  class: "submitBlock"
};
const _hoisted_22 = {
  class: "selectBox"
};
import useDetailHooks from './hooks/useDetailHooks';
import RecordDrawer from './components/RecordDrawer.vue';
import { cloneDeep } from 'lodash';
import { queryGoods, addGoods, updGoods, queryPkgInfo, queryBasicPlanSelections, translator } from '@/api/goodsSetting';
import { useRoute, useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import { awaitWrap, getNode, OK, reportEvent } from '@/common';
import { QuestionCircleOutlined } from '@ant-design/icons-vue';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'zijieMiniGameDetail'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const {
      huaweiProdTypeOptions,
      validatePid
    } = useDetailHooks();
    const typeDisabled = ref(true);
    const disabled = ref(false); // 禁用改动
    const rateDisabled = ref(false); // 禁用改动
    const detailFormInit = {
      os: 1,
      prodType: undefined,
      productNativeInfo: '',
      remark: '',
      prodId: '',
      zoneId: '',
      testStatus: false,
      price: 1,
      rate: undefined,
      testPrice: '1.00',
      pkg: '' // 包名
    };
    const recordVisible = ref(false);
    const queryParams = ref({
      prodChnl: '',
      dbtId: '',
      id: null // 商品主键
    });
    const saveNext = ref(false); // 是否连续创建，保存后留在本页，清空配置信息，保留其他例如价格信息
    const rateOptions = ref([]); // 兑换比例
    const priceOptions = ref([]); // 兑换比例
    const myFormRef = ref(null);
    const priceLoading = ref(false);
    const saveLoading = ref(false); // 保存按钮可用性
    const settingForm = ref(cloneDeep(detailFormInit));
    const getDetail = async () => {
      const res = await queryGoods({
        id: queryParams.value.id
      });
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        var _res$data, _res$data2;
        settingForm.value = {
          ...res.data,
          zoneId: res.data.payConfig.zoneId,
          rate: res.data.payConfig.rate,
          price: (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.officePrices) === null || _res$data === void 0 || (_res$data = _res$data[0]) === null || _res$data === void 0 ? void 0 : _res$data.price,
          testPrice: (_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.testPrices) === null || _res$data2 === void 0 || (_res$data2 = _res$data2[0]) === null || _res$data2 === void 0 ? void 0 : _res$data2.price
        };
      }
    }; // 查询详情信息
    const getPkg = async () => {
      const res = await queryPkgInfo({
        dbtId: queryParams.value.dbtId,
        prodChnl: queryParams.value.prodChnl
      });
      typeDisabled.value = false;
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        var _res$data3;
        settingForm.value.pkg = res.data.pkg;
        settingForm.value.prodId = res.data.pkg;
        settingForm.value.rate = res.data.rate;
        rateDisabled.value = !!((_res$data3 = res.data) !== null && _res$data3 !== void 0 && _res$data3.rate);
      }
    }; //查询包名等信息
    const getPriceList = async () => {
      const [err, res] = await awaitWrap(queryBasicPlanSelections({
        prodChnl: queryParams.value.prodChnl
      }));
      if (err) return;
      if (res && res.code === OK) {
        var _res$data4, _res$data5;
        priceOptions.value = (_res$data4 = res.data) === null || _res$data4 === void 0 || (_res$data4 = _res$data4.priceLevel) === null || _res$data4 === void 0 ? void 0 : _res$data4.map(item => {
          return {
            label: item === null || item === void 0 ? void 0 : item.name,
            value: item === null || item === void 0 ? void 0 : item.value
          };
        });
        rateOptions.value = (_res$data5 = res.data) === null || _res$data5 === void 0 || (_res$data5 = _res$data5.rate) === null || _res$data5 === void 0 ? void 0 : _res$data5.map(item => {
          return {
            label: item === null || item === void 0 ? void 0 : item.name,
            value: item === null || item === void 0 ? void 0 : item.value
          };
        });
      }
    }; // 获取价格
    const cancel = () => {
      window.history.go(-1);
    }; // 取消逻辑
    const save = async () => {
      myFormRef.value.validate().then(async valid => {
        try {
          if (valid) {
            let fn = queryParams.value.id ? updGoods : addGoods;
            let params = {
              ...settingForm.value,
              dbtId: queryParams.value.dbtId,
              prodType: settingForm.value.prodType,
              pkg: settingForm.value.pkg,
              prodId: settingForm.value.prodId,
              remark: settingForm.value.remark,
              // 支付配置
              payConfig: {
                zoneId: settingForm.value.zoneId,
                rate: settingForm.value.rate // 比率，必填
              },
              // 测试开关
              testStatus: settingForm.value.testStatus,
              // 正式价格配置，必填
              officePrices: [{
                price: settingForm.value.price,
                currency: 'CNY' // 货币，必填
              }],
              // 测试价格配置，必填
              testPrices: [{
                price: settingForm.value.testPrice,
                currency: 'CNY' // 货币，必填
              }],
              syncCreateIosPlatProd: true,
              prodChnl: queryParams.value.prodChnl
            };
            if (params.pkg === params.prodId) {
              return message.error('内购ID不可完全等于包名，请手动补齐内购ID后半部分');
            }
            saveLoading.value = true;
            const res = await fn(params);
            saveLoading.value = false;
            if (res.code === '0') {
              reportEvent({
                eventName: 'element_use',
                properties: {
                  ui_name: '字节小游戏商品配置',
                  element_name: '保存'
                }
              });
              message.success('商品保存成功！');
              if (!saveNext.value) {
                await router.push({
                  name: 'goodsSetting'
                });
              } else {
                settingForm.value = {
                  ...cloneDeep(detailFormInit),
                  pkg: settingForm.value.pkg,
                  zoneId: settingForm.value.zoneId,
                  rate: settingForm.value.rate,
                  prodId: settingForm.value.pkg
                };
              }
            }
          }
        } catch (error) {}
      });
    }; // 保存逻辑
    const validateProdName = (_rule, value) => {
      // 不得大于128 字符
      if ((value === null || value === void 0 ? void 0 : value.length) > 128) {
        return Promise.reject('不得大于128字符');
      }
      return Promise.resolve();
    };
    const changeName = async () => {
      var _settingForm$value;
      settingForm.value.prodName = (_settingForm$value = settingForm.value) === null || _settingForm$value === void 0 || (_settingForm$value = _settingForm$value.prodName) === null || _settingForm$value === void 0 ? void 0 : _settingForm$value.trim();
      if (!settingForm.value.prodName) return;
      try {
        const [err, res] = await awaitWrap(translator({
          sourceLang: 'zh-cn',
          sourceText: settingForm.value.prodName,
          targetLang: ['en_Us']
        }));
        if (err) {}
        if (res && res.code === OK) {
          setProdId(res.data.translateList[0].translatedResult);
        }
      } catch (e) {}
    }; // 商品名自动翻译
    const setProdId = e => {
      e = e.trim();
      if (queryParams.value.id) return; // 编辑时不允许修改内购ID
      let pkgStr = settingForm.value.pkg; // 拼接前缀
      let lengthLimit = 140; // 最大字符数
      if (!e.length) {
        // 值为空的时候赋值为包名
        settingForm.value.prodId = pkgStr;
        return;
      }
      try {
        var _getStr$match;
        let getStr = e.toLowerCase().replace(/\s*/g, '');
        getStr = ((_getStr$match = getStr.match(/[a-z0-9\.]/g)) === null || _getStr$match === void 0 ? void 0 : _getStr$match.join('')) || '';
        let countStr = lengthLimit - pkgStr.length - 1;
        settingForm.value.prodId = pkgStr + '.' + getStr.slice(0, countStr);
      } catch (error) {}
    }; // 根据商品名/订阅名，内购ID自动拼接
    const handleTestStatusChange = e => {
      if (e && ['0.1', '0.2', '0.3'].includes(settingForm.value.price)) {
        settingForm.value.testPrice = '0.1';
      } else {
        settingForm.value.testPrice = '1.00';
      }
    };
    const handlePriceChange = e => {
      if (e && ['0.1', '0.2', '0.3'].includes(e)) {
        settingForm.value.testPrice = '0.1';
      } else {
        settingForm.value.testPrice = '1.00';
      }
    };
    onMounted(async () => {
      queryParams.value = {
        ...route.query
      };
      await getPkg();
      await getPriceList();
      if (route.query.type === 'watch') {
        disabled.value = true;
        rateDisabled.value = true;
      }
      if (queryParams.value.id) {
        rateDisabled.value = true;
        await getDetail();
      }
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_switch = _resolveComponent("a-switch");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref_key: "myFormRef",
        ref: myFormRef,
        model: settingForm.value,
        "label-col": {
          style: 'width: 120px'
        },
        autocomplete: "off"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createTextVNode(" 抖音小游戏商品配置 "), _createElementVNode("div", {
          class: "record-text",
          onClick: _cache[0] || (_cache[0] = $event => recordVisible.value = true)
        }, "变更记录")]), _createVNode(_component_a_form_item, {
          label: "商品类型",
          name: "prodType",
          rules: [{
            required: true,
            type: 'string'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            placeholder: "请选择商品类型",
            class: "inputer",
            value: settingForm.value.prodType,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => settingForm.value.prodType = $event),
            options: _unref(huaweiProdTypeOptions),
            disabled: typeDisabled.value || disabled.value,
            getPopupContainer: _unref(getNode)
          }, {
            option: _withCtx(({
              label,
              describtion
            }) => [_createElementVNode("div", _hoisted_5, _toDisplayString(label), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(describtion), 1)]),
            _: 1
          }, 8, ["value", "options", "disabled", "getPopupContainer"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "备注"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            class: "bigInputer",
            value: settingForm.value.remark,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => settingForm.value.remark = $event),
            placeholder: "请输入",
            disabled: disabled.value,
            maxLength: 20
          }, null, 8, ["value", "disabled"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "商品信息",
          name: "prodName",
          rules: [{
            required: true,
            type: 'string'
          }, {
            validator: validateProdName,
            trigger: 'blur'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            class: "bigInputer",
            value: settingForm.value.prodName,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => settingForm.value.prodName = $event),
            placeholder: "请输入商品名称",
            onBlur: changeName
          }, null, 8, ["value"])]),
          _: 1
        }, 8, ["rules"]), _createVNode(_component_a_form_item, {
          label: "内购ID",
          name: "prodId",
          rules: [{
            required: true,
            trigger: ['change', 'blur'],
            validator: _unref(validatePid)
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            class: "inputer",
            value: settingForm.value.prodId,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => settingForm.value.prodId = $event),
            placeholder: "请输入内购ID",
            disabled: Boolean(queryParams.value.id) || disabled.value
          }, null, 8, ["value", "disabled"]), _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_hoisted_7]),
            default: _withCtx(() => [_createVNode(_unref(QuestionCircleOutlined), {
              class: "infoIcon ml8"
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["rules"])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_form_item, {
          label: "兑换比例",
          name: "rate",
          rules: [{
            required: true,
            message: '请发布先在支付配置中完成兑换比例填写'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            disabled: rateDisabled.value,
            class: "inputer",
            value: settingForm.value.rate,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => settingForm.value.rate = $event),
            options: rateOptions.value,
            placeholder: "请选择"
          }, null, 8, ["disabled", "value", "options"]), _hoisted_10]),
          _: 1
        })]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_a_form_item, {
          label: "默认价格",
          name: "price",
          required: ""
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_a_select, {
            class: "inputer",
            value: settingForm.value.price,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => settingForm.value.price = $event),
            options: priceOptions.value,
            placeholder: "选择默认价格",
            onChange: handlePriceChange
          }, null, 8, ["value", "options"]), _hoisted_14, _hoisted_15])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "开启测试价格",
          name: "testStatus"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_a_switch, {
            checked: settingForm.value.testStatus,
            "onUpdate:checked": _cache[7] || (_cache[7] = $event => settingForm.value.testStatus = $event),
            onChange: handleTestStatusChange
          }, null, 8, ["checked"]), _hoisted_17])]),
          _: 1
        }), settingForm.value.testStatus ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 0,
          label: "测试价格",
          name: "testPrice"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_a_select, {
            disabled: "",
            class: "inputer",
            value: settingForm.value.testPrice,
            "onUpdate:value": _cache[8] || (_cache[8] = $event => settingForm.value.testPrice = $event),
            options: priceOptions.value,
            placeholder: "选择测试价格"
          }, null, 8, ["value", "options"]), _hoisted_19, _hoisted_20])]),
          _: 1
        })) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["model"]), _withDirectives(_createElementVNode("div", _hoisted_21, [_createVNode(_component_a_button, {
        onClick: cancel
      }, {
        default: _withCtx(() => [_createTextVNode("取 消")]),
        _: 1
      }), _createVNode(_component_a_button, {
        loading: saveLoading.value,
        class: "ml8",
        type: "primary",
        onClick: save,
        disabled: priceLoading.value
      }, {
        default: _withCtx(() => [_createTextVNode(" 保 存 ")]),
        _: 1
      }, 8, ["loading", "disabled"]), _withDirectives(_createElementVNode("div", _hoisted_22, [_createVNode(_component_a_checkbox, {
        checked: saveNext.value,
        "onUpdate:checked": _cache[9] || (_cache[9] = $event => saveNext.value = $event)
      }, {
        default: _withCtx(() => [_createTextVNode("连续创建")]),
        _: 1
      }, 8, ["checked"])], 512), [[_vShow, !queryParams.value.id]])], 512), [[_vShow, !disabled.value]]), _createVNode(RecordDrawer, {
        visible: recordVisible.value,
        "onUpdate:visible": _cache[10] || (_cache[10] = $event => recordVisible.value = $event)
      }, null, 8, ["visible"])]);
    };
  }
});